

export class PoiTypeAddAddInput implements IPoiTypeAddAddInput {
    /** The Poi type name with 255 character limit */
    poiTypeName!: string;

    constructor(data?: IPoiTypeAddAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiTypeName = _data["poiTypeName"];
        }
    }

    static fromJS(data: any): PoiTypeAddAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeAddAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiTypeName"] = this.poiTypeName;
        return data; 
    }
}

export interface IPoiTypeAddAddInput {
    /** The Poi type name with 255 character limit */
    poiTypeName: string;
}

